import React from 'react'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { XDivider } from 'irmlib/styles'
import Papa from 'papaparse'
import { Button } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const ExportCsv = (props) => {
  const { columns, isDisabled, isNoData, isNoPageData, table, hideExportSelectedData, hideExportPageData } = props
  const { t } = useTranslation()

  // #1087:For exporting csv Data
  const exportCSV = (rows, filename) => {
    const csvString = Papa.unparse(rows)
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  
  const getRows = (table, isSelected = false) => {
    const rows = isSelected
      ? table.getSelectedRowModel().rows.map(row => row.original)
      : table.getRowModel().rows.map(row => row.original)
  
    return rows.map(row => {
      return columns.reduce((acc, col) => {
        acc[col.header] = row[col.accessorKey]
        return acc
      }, {})
    })
  }

  const getAllRows = (table) => {
    const rows = table.getCoreRowModel().rows.map(row => row.original)
  
    return rows.map(row => {
      return columns.reduce((acc, col) => {
        acc[col.header] = row[col.accessorKey]
        return acc
      }, {})
    })
  }

  const handleExport = (table) => {
    const allData = getAllRows(table, true)
    exportCSV(allData, 'data.csv')
  }
  
  const handleExportSelected = (table) => {
    const rows = getRows(table, true)
    exportCSV(rows, 'selected_data.csv')
  }
  
  const handleExportPerPage = (table) => {
    const rowsPerPage = getRows(table)
    exportCSV(rowsPerPage, 'data_perPage.csv')
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button
        disabled={isNoData}
        style={{
          color: isNoData ? '#C8C8C8' : '#58595B',
          fontWeight: 'bold'
        }}
        onClick={() => handleExport(table)}
        endIcon={<FileDownloadIcon />}>{t('smartCatalog.exportAllData')}
      </Button>
      <XDivider width='10px' />
      { !hideExportSelectedData && 
      <Button
        onClick={() => handleExportSelected(table)}
        disabled={isDisabled}
        style={{
          color: isDisabled ? '#C8C8C8' : '#58595B',
          fontWeight: 'bold'
        }}
        endIcon={<FileDownloadIcon />}>{t('smartCatalog.exportSelectedData')}
      </Button> }
      <XDivider width='10px' />
      { !hideExportPageData && <Button
        disabled={!isNoPageData}
        style={{
          color: !isNoPageData ? '#C8C8C8' : '#58595B',
          fontWeight: 'bold'
        }}
        onClick={() => handleExportPerPage(table)}
        endIcon={<FileDownloadIcon />}>{t('smartCatalog.exportPageData')}
      </Button> }
    </div>
  )
}

ExportCsv.propTypes = {
  columns: PropTypes.any,
  isDisabled: PropTypes.any,
  isNoData: PropTypes.any,
  isNoPageData: PropTypes.any,
  table: PropTypes.any,
}

export default ExportCsv